import { EnvConfig } from '@config';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const FEEDBACK_EVENT_PREFIX = 'FEEDBACK_';
export const LESSON_LEARNT_APPROVED_EVENT = 'LESSON_LEARNT_APPROVED';

// In Jest (NODE_ENV === 'test') we avoid calling loadAppInsights to prevent real network
// requests that keep open TLS/TCP handles and trigger --detectOpenHandles warnings.
// We still export an ApplicationInsights instance (lazy / uninitialized) so that code
// depending on its interface does not break in tests.
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: EnvConfig.instrumentationKey,
  },
});

if (process.env.NODE_ENV !== 'test') {
  appInsights.loadAppInsights();
}

export const setAuthenticatedUser = (authenticatedUserId: string, accountId: string) => {
  appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, true);
};

export const loadedAppInsights = appInsights;
